import { node } from "~/util/dom";

interface IContextMenuItemProps {
	icon: HTMLElement;
	text: string;
	onClick: (event: PointerEvent) => void;
}

const DEFAULT_PROPS: IContextMenuItemProps = {
	icon: null,
	text: "",
	onClick: null,
};

export default class ContextMenuItem {
	#container: HTMLButtonElement;

	#props: IContextMenuItemProps;

	constructor(props: Partial<IContextMenuItemProps> & Pick<IContextMenuItemProps, "text">) {
		this.#props = {
			...DEFAULT_PROPS,
			...props,
		};
		this.#container = node("button", { type: "button", className: "ui-contextmenuitem" });
		this.#props.onClick && this.#container.addEventListener("click", this.#props.onClick, false);

		if (props.icon) {
			props.icon.classList.add("ui-contextmenuitem__icon");
			this.#container.appendChild(props.icon);
		}
		this.#container.appendChild(node("span", { className: "ui-contextmenuitem__text", innerText: props.text }));
	}

	destroy() {
		this.#props.onClick && this.#container.removeEventListener("click", this.#props.onClick, false);
	}

	get container() {
		return this.#container;
	}
}
